import axios from 'axios'
import { environment } from '@/data/environment/'

export default {
  namespaced: true,
  state: {
    error: null,
    dashboard: null,
    searchResults: null,
    eventDetail: null,
    errorsAnalysis: null,
    loadingDashboard: false,
    loadingSearch: false,
    loadingDetail: false,
    loadingErrors: false,
  },
  mutations: {
    setDashboard (state, data) {
      state.dashboard = data
      state.error = null
    },
    setSearchResults (state, data) {
      state.searchResults = data
      state.error = null
    },
    setEventDetail (state, data) {
      state.eventDetail = data
      state.error = null
    },
    setErrorsAnalysis (state, data) {
      state.errorsAnalysis = data
      state.error = null
    },
    setLoading (state, { key, value }) {
      state[key] = value
    },
    setError (state, error) {
      state.error = error
    },
  },
  actions: {
    getDashboard ({ commit }, days = 7) {
      commit('setLoading', { key: 'loadingDashboard', value: true })
      const url = environment.HIOPOSWEBSERVICES + `/wide-events/dashboard?days=${days}`

      return axios.create().get(url)
        .then(response => {
          if (response.data.success) {
            commit('setDashboard', response.data.data)
          } else {
            commit('setError', response.data.message || 'Error al obtener dashboard')
          }
        })
        .catch(error => {
          console.error('Error getDashboard:', error.message)
          commit('setError', error.message)
        })
        .finally(() => {
          commit('setLoading', { key: 'loadingDashboard', value: false })
        })
    },

    searchEvents ({ commit }, filters) {
      commit('setLoading', { key: 'loadingSearch', value: true })

      let params = []
      if (filters.trace_id) params.push(`trace_id=${filters.trace_id}`)
      if (filters.company_id) params.push(`company_id=${filters.company_id}`)
      if (filters.prefijo) params.push(`prefijo=${filters.prefijo}`)
      if (filters.consecutivo) params.push(`consecutivo=${filters.consecutivo}`)
      if (filters.access_key) params.push(`access_key=${filters.access_key}`)
      if (filters.has_errors !== null && filters.has_errors !== undefined && filters.has_errors !== '') {
        params.push(`has_errors=${filters.has_errors}`)
      }
      if (filters.source_process) params.push(`source_process=${filters.source_process}`)
      if (filters.final_status) params.push(`final_status=${filters.final_status}`)
      if (filters.date_from) params.push(`date_from=${filters.date_from}`)
      if (filters.date_to) params.push(`date_to=${filters.date_to}`)

      const queryString = params.length > 0 ? '?' + params.join('&') : ''
      const url = environment.HIOPOSWEBSERVICES + `/wide-events/search${queryString}`

      return axios.create().get(url)
        .then(response => {
          if (response.data.success) {
            commit('setSearchResults', response.data.data)
          } else {
            commit('setError', response.data.message || 'Error al buscar eventos')
          }
        })
        .catch(error => {
          console.error('Error searchEvents:', error.message)
          commit('setError', error.message)
        })
        .finally(() => {
          commit('setLoading', { key: 'loadingSearch', value: false })
        })
    },

    getEventDetail ({ commit }, traceId) {
      commit('setLoading', { key: 'loadingDetail', value: true })
      commit('setEventDetail', null)
      const url = environment.HIOPOSWEBSERVICES + `/wide-events/${traceId}`

      return axios.create().get(url)
        .then(response => {
          if (response.data.success) {
            commit('setEventDetail', response.data.data)
          } else {
            commit('setError', response.data.message || 'Evento no encontrado')
          }
        })
        .catch(error => {
          console.error('Error getEventDetail:', error.message)
          commit('setError', error.message)
        })
        .finally(() => {
          commit('setLoading', { key: 'loadingDetail', value: false })
        })
    },

    getErrorsAnalysis ({ commit }, days = 7) {
      commit('setLoading', { key: 'loadingErrors', value: true })
      const url = environment.HIOPOSWEBSERVICES + `/wide-events/errors/analysis?days=${days}`

      return axios.create().get(url)
        .then(response => {
          if (response.data.success) {
            commit('setErrorsAnalysis', response.data.data)
          } else {
            commit('setError', response.data.message || 'Error al obtener análisis')
          }
        })
        .catch(error => {
          console.error('Error getErrorsAnalysis:', error.message)
          commit('setError', error.message)
        })
        .finally(() => {
          commit('setLoading', { key: 'loadingErrors', value: false })
        })
    },
  },
}
